/**
 * cat_cookies.js v1.0.1
 * http://www.catapult.be
 * Vanilla javascript
 * Copyright 2022, Catapult
 * http://www.catapult.be
 */

 var cookie_widget = {

   cookie_pref_set: false,
   settings: {},
   necessary: null,
   social: null,
   analytics: null,
   advertising: null,

   init: function (settings){
      this.settings = settings;
      this.cookie_pref_set = this.getCookie('cookie_pref_set');
      this.loadPrefs();

      if (this.settings.necessary.active)   this.addClass('cookie-item-necessary','active');
      if (this.settings.social.active)      this.addClass('cookie-item-social','active');
      if (this.settings.analytics.active)   this.addClass('cookie-item-analytics','active');
      if (this.settings.advertising.active) this.addClass('cookie-item-advertising','active');

      this.setupInfoButtons();
      this.setupButtons();

      if (this.cookie_pref_set)  this.call_callBacks();
      else                       this.show_cookie_info();
   },


   show_cookie_info: function(){
     cookie_widget.addClass('cookie-info-window','active');
   },

   hide_cookie_info: function(){
     cookie_widget.removeClass('cookie-info-window','active');
   },

   setPrefsBtnClick: function(){
     cookie_widget.hide_cookie_info();
     cookie_widget.show_cookie_prefs();
   },

   setupInfoButtons: function(){
     var acceptAll = document.getElementById('accept-all-btn');
     acceptAll.addEventListener("click", this.acceptAll);

     var setCookiePrefs = document.getElementById('set-cookie-pref-btn');
     setCookiePrefs.addEventListener("click", this.setPrefsBtnClick);
   },

   acceptAll: function(){
     cookie_widget.necessary   = 'true';
     cookie_widget.social      = 'true';
     cookie_widget.analytics   = 'true';
     cookie_widget.advertising = 'true';
     cookie_widget.updateRadios();
     cookie_widget.save_cookie_preferences();
     cookie_widget.hide_cookie_info();
   },

   call_callBacks: function(){
     if (this.settings.necessary.callback!=null)    this.settings.necessary.callback(this.necessary);
     if (this.settings.analytics.callback!=null)    this.settings.analytics.callback(this.analytics);
     if (this.settings.advertising.callback!=null)  this.settings.advertising.callback(this.advertising);
     if (this.settings.social.callback!=null)       this.settings.social.callback(this.social);
   },

   setRadio: function(name, value){
     var radioButtons = document.querySelectorAll("input[name="+name+"]");
     for (var i = 0; i < radioButtons.length; i++) {
         if (radioButtons[i].value == value) radioButtons[i].checked = true;
         else radioButtons[i].checked = false;
     }
   },

   updateRadios: function(){
     cookie_widget.setRadio('necessary',cookie_widget.necessary);
     cookie_widget.setRadio('social',cookie_widget.social);
     cookie_widget.setRadio('analytics',cookie_widget.analytics);
     cookie_widget.setRadio('advertising',cookie_widget.advertising);
     cookie_widget.checkSubmit();
   },

   loadPrefs: function(){
     if (this.cookie_pref_set){
         this.necessary   = this.getCookie('allow_cookie_necessary');
         this.social      = this.getCookie('allow_cookie_social');
         this.analytics   = this.getCookie('allow_cookie_analytics');
         this.advertising = this.getCookie('allow_cookie_advertising');
     }
     else{
         this.necessary   = this.settings.necessary.default;
         this.social      = this.settings.social.default;
         this.analytics   = this.settings.analytics.default;
         this.advertising = this.settings.advertising.default;
     }

     this.updateRadios();
   },

   addClass: function(id, className){
     var elm = document.getElementById(id);
     elm.classList.add(className);
   },
   removeClass: function(id, className){
     var elm = document.getElementById(id);
     elm.classList.remove(className);
   },

   show_cookie_prefs: function(){
     cookie_widget.addClass('cookie-prefs-window','active');
   },

   hide_cookie_prefs: function(){
     cookie_widget.removeClass('cookie-prefs-window','active');
   },

   save_cookie_preferences: function (){
     cookie_widget.setCookie('allow_cookie_necessary',cookie_widget.necessary,365);
     cookie_widget.setCookie('allow_cookie_analytics',cookie_widget.analytics,365);
     cookie_widget.setCookie('allow_cookie_advertising',cookie_widget.advertising,365);
     cookie_widget.setCookie('allow_cookie_social',cookie_widget.social,365);
     cookie_widget.setCookie('cookie_pref_set','true',365);
     cookie_widget.hide_cookie_prefs();
     cookie_widget.call_callBacks();
   },

   backBtnClick: function(){
     cookie_widget.show_cookie_info();
     cookie_widget.hide_cookie_prefs();
   },

   setupButtons: function(){

     var save_cookie_pref = document.getElementById('save_cookie_pref');
     save_cookie_pref.addEventListener("click", this.save_cookie_preferences);

     var backBtn = document.getElementById('back-btn');
     backBtn.addEventListener("click", this.backBtnClick);

     var necessary_radios = document.querySelectorAll("input[name=necessary]");
     for(var i = 0, max = necessary_radios.length; i < max; i++) {
         necessary_radios[i].onclick = function() {
             cookie_widget.necessary = this.value;
             cookie_widget.checkSubmit();
         }
         if (!this.settings.necessary.edit)  {
           necessary_radios[i].disabled = true;
           cookie_widget.addClass('cookie-item-necessary','disabled');
         }
     }

     var social_radios = document.querySelectorAll("input[name=social]");
     for(var i = 0, max = social_radios.length; i < max; i++) {
         social_radios[i].onclick = function() {
             cookie_widget.social = this.value;
             cookie_widget.checkSubmit();
         }
         if (!this.settings.social.edit)  {
           social_radios[i].disabled = true;
           cookie_widget.addClass('cookie-item-social','disabled');
         }
     }

     var analytics_radios = document.querySelectorAll("input[name=analytics]");
     for(var i = 0, max = analytics_radios.length; i < max; i++) {
         analytics_radios[i].onclick = function() {
             cookie_widget.analytics = this.value;
             cookie_widget.checkSubmit();
         }
         if (!this.settings.analytics.edit)  {
           analytics_radios[i].disabled = true;
           cookie_widget.addClass('cookie-item-analytics','disabled');
         }
     }

     var advertising_radios = document.querySelectorAll("input[name=advertising]");
     for(var i = 0, max = advertising_radios.length; i < max; i++) {
         advertising_radios[i].onclick = function() {
             cookie_widget.advertising = this.value;
             cookie_widget.checkSubmit();
         }
         if (!this.settings.advertising.edit)  {
           advertising_radios[i].disabled = true;
           cookie_widget.addClass('cookie-item-advertising','disabled');
         }
     }

   },

   checkSubmit: function(){
       var disabled = false;
       if (this.settings.necessary.active)   disabled = disabled || this.necessary==null;
       if (this.settings.social.active)      disabled = disabled || this.social==null;
       if (this.settings.analytics.active)   disabled = disabled || this.analytics==null;
       if (this.settings.advertising.active) disabled = disabled || this.advertising==null;

       document.getElementById('save_cookie_pref').disabled = disabled;
   },

   setCookie: function(cname, cvalue, exdays) {
     var d = new Date();
     d.setTime(d.getTime() + (exdays*24*60*60*1000));
     var expires = "expires="+ d.toUTCString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   },

   getCookie: function(cname) {
     var name = cname + "=";
     var ca = document.cookie.split(';');
     for(var i = 0; i < ca.length; i++) {
       var c = ca[i];
       while (c.charAt(0) == ' ') {
         c = c.substring(1);
       }
       if (c.indexOf(name) == 0) {
         return c.substring(name.length, c.length);
       }
     }
     return null;
   }


 };

 export default cookie_widget;
